module.exports = __webpack_public_path__ + "static/media/Psyduck_gaussian2.b7d401df.png";